import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Box, Button, CssBaseline, Grid, Paper, Typography } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ManageCollectionEntries from "./Fragments/ManageCollectionEntries";
import AppTheme from "../../../theme/AppTheme";
import { dataGridCustomizations } from "../../../theme/customizations";

const CollectionEntriesPage = (props: { disableCustomTheme?: boolean }) => {
  const navigate = useNavigate();
  const { collectionId } = useParams<{ collectionId: string }>();
  const parsedCollectionId = Number(collectionId);
  const xThemeComponents = {
    ...dataGridCustomizations,
  };

  return (
    <AppTheme {...props} themeComponents={xThemeComponents}>
      <CssBaseline enableColorScheme />
      <Box sx={{ width: "100%", maxWidth: { sm: "100%", md: "1700px" } }}>
        <Grid
          container
          columns={12}
          spacing={2}
          sx={{ mb: (theme) => theme.spacing(2), width: "auto" }}
        >
          <Paper sx={{ p: 2, minHeight: "70vh", mb: 2, borderRadius: 3, width: "100%" }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 2,
              }}
            >
              <Typography variant="h6">Manage Collection Entries</Typography>
              <Button
                variant="outlined"
                size="small"
                startIcon={<ArrowBackIcon />}
                sx={{ textTransform: "none", borderRadius: 2 }}
                onClick={() => navigate("/collection-management")}
              >
                Back to Collections
              </Button>
            </Box>
            {Number.isFinite(parsedCollectionId) && parsedCollectionId > 0 ? (
              <ManageCollectionEntries
                collectionId={parsedCollectionId}
                onClose={() => navigate("/collection-management")}
              />
            ) : (
              <Typography color="error">Invalid collection ID</Typography>
            )}
          </Paper>
        </Grid>
      </Box>
    </AppTheme>
  );
};

export default CollectionEntriesPage;
